import { Anchor, Badge, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import {
  IconBrandFacebook,
  IconBrandGoogle,
  IconHistory,
  IconInfoCircle,
  IconRefresh,
  IconUsers,
} from '@tabler/icons-react';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import AudienceInfoModal from '../Modals/AudienceInfoModal';

const SyncSegmentsCard = ({ segmentSync, status }) => {
  const { accountId, domainId } = useParams();
  const location = useLocation();
  const [show, setShow] = useState();
  const linkToSegment = segmentSync.segment
    ? `#/accounts/${accountId}/domains/${domainId}/segments/${segmentSync.segment.id}`
    : null;

  const getTypeIcon = (type) => {
    switch (type) {
      case 'facebook':
        return <IconBrandFacebook size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />;
      case 'google':
        return <IconBrandGoogle size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />;
      default:
        return <IconRefresh size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />;
    }
  };

  return (
    <>
      <AudienceInfoModal
        show={show}
        close={() => setShow(false)}
        externalId={segmentSync?.externalId}
        type={segmentSync?.type}
      />
      <Card mb="md" data-tour="segmentSyncCard" withBorder>
        <Card.Section inheritPadding py="sm">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <Anchor
                href={`#${location.pathname}/${segmentSync.id}/details`}
                fw={600}
                mb="xs"
                style={{ display: 'block' }}
              >
                {segmentSync.name}
              </Anchor>
              <Flex gap="xs" wrap="wrap">
                <Badge variant="default">
                  <IconUsers size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  <Anchor href={linkToSegment} target="_blank" size="xs">
                    {segmentSync.segment?.name || 'Unknown'}
                  </Anchor>
                </Badge>
                <Badge variant="default">
                  {getTypeIcon(segmentSync.type)}
                  {prettifiedLabel(segmentSync.type)}
                </Badge>
                {segmentSync.externalId && (
                  <>
                    <Badge variant="default">
                      {segmentSync.type === 'facebook' ? 'Facebook' : 'Google'} ID: {segmentSync.externalId}
                      <Button
                        variant="subtle"
                        size="compact-xs"
                        onClick={() => setShow(true)}
                        style={{ marginLeft: 4 }}
                      >
                        <IconInfoCircle size={14} />
                      </Button>
                    </Badge>
                    <Badge variant="default">
                      {segmentSync.type === 'facebook' ? 'Facebook' : 'Google'} Audience Name:{' '}
                      {segmentSync.name + ' - ' + segmentSync.uniqueIdForName}
                    </Badge>
                  </>
                )}
                <Tooltip
                  label={
                    <>
                      <div>Created: {new Date(segmentSync.createdAt).toLocaleString()}</div>
                      <div>Updated: {new Date(segmentSync.updatedAt).toLocaleString()}</div>
                    </>
                  }
                  position="top"
                  withArrow
                >
                  <Badge variant="default" style={{ cursor: 'pointer' }}>
                    <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                  </Badge>
                </Tooltip>
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Flex justify="flex-end" align="flex-start">
                <span data-tour="segmentSyncStatus">{status}</span>
              </Flex>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    </>
  );
};

export default SyncSegmentsCard;
